import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import "./CppoCodeListDetails.css";
import { NewClientRequestForm } from '../newClientRequest/newClientRequestForm';

export default function CPPRequestDetails(props: any) {
  function HideDialog() {
    props.CPPDetails(false);
    setVisibleDiv1(true);
    setVisibleDiv2(false);
    setVisibleDiv3(false);
    setVisibleDiv4(false);
    setVisibleDiv5(false);
  }

  interface RequestDetails {
    requestedStartDate?: string;
    segmentAttributeAlloc?: string;
    [key: string]: any;
  }

  const [requestDetails, setRequestDetails] = useState<RequestDetails>({});
  const [isVisibleDiv1, setVisibleDiv1] = useState(true);
  const [isVisibleDiv2, setVisibleDiv2] = useState(false);
  const [isVisibleDiv3, setVisibleDiv3] = useState(false);
  const [isVisibleDiv4, setVisibleDiv4] = useState(false);
  const [isVisibleDiv5, setVisibleDiv5] = useState(false);
  const [requestedStartDate, setRequestedStartDate] = useState("");
  const [showAllocations, setShowAllocations] = useState(false);
  const [divHeight, setDivHeight] = useState("");
  const [segmentname, setSegmentName] = useState("");

  useEffect(() => {
    setRequestDetails(props.requestDetails);

    if (
      requestDetails &&
      requestDetails["requestedStartDate"] &&
      !requestDetails["requestedStartDate"].includes("0001")
    ) {
      setRequestedStartDate(requestDetails["requestedStartDate"]);
    } else {
      setRequestedStartDate("");
    }

    var name = props.requestDetails["segmentAttributeAlloc"];
    setSegmentName(name);
    if (name === "Percepta") {
      setShowAllocations(false);
      setDivHeight("620px");
    } else {
      setShowAllocations(true);
      setDivHeight("1260px");
    }
  });

  let onHideShowClick = (divId: number) => {
    if (divId == 0) {
      setVisibleDiv1(true);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
    if (divId == 1) {
      setVisibleDiv1(false);
      setVisibleDiv2(true);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
    if (divId == 2) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(true);
      setVisibleDiv4(false);
      setVisibleDiv5(false);
    }
    if (divId == 3) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(true);
      setVisibleDiv5(false);
    }
    if (divId == 4) {
      setVisibleDiv1(false);
      setVisibleDiv2(false);
      setVisibleDiv3(false);
      setVisibleDiv4(false);
      setVisibleDiv5(true);
    }
  };

  return (
    <div>
      <Dialog
        visible={props.visible}
        style={{ width: "1200px" }}
        onHide={HideDialog}
        header=<h3>View CPP Request</h3>
      >
        <div>
          <NewClientRequestForm showHeader={false} requestDetails={requestDetails}  CPPEditForm={props.CPPEditForm} mode="View"></NewClientRequestForm>  
        </div>
      </Dialog>
    </div>
  );
}
